import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import * as moment from 'moment';
import {connect} from 'react-redux';

import './CouponCard.css';

import {Avatar, OptionsButton, PrimaryButton, Spinner} from '../../../widgets';
import {uiActions} from '../../../chrome';
import confirmActions from '../../../widgets/confirmation.actions';
import couponActions from '../coupons.actions';
import {notificationsActions} from '../../../user';

class CouponCard extends Component {
	// function handle redirection with coupon is clicked
	couponClickHandler = e => {
		// if user is not logged in, show login model
		if (!this.props.authenticated) {
			this.props.showLogin();
			return;
		}

		if (this.props.redirectLink) {
			this.props.history.push(this.props.redirectLink);
		}
	};

	// click handler to redirect to providers profile when avtar image
	//or provider name is cliced
	avtarClickHandler = e => {
		e.stopPropagation();
		if (this.props.providerProfileLink) {
			this.props.history.push(this.props.providerProfileLink);
		}
	};

	// stopping event bubbling when toggle icon is cliced
	// to make sure toggle buttons are shown instead of redirection event
	toggleClicked = e => {
		e.stopPropagation();
	};

	render() {
		const {
			size,
			screenSize,
			avatarImage,
			firstname,
			lastname,
			businessName,
			description,
			productLink,
			code,
			couponUuid,
			expiryDate,
			children,
			showActions,
			options,
			showOptions,
			canRedeem,
			redeemDisabled,
			confirmReedem,
			coupon,
			showCommunityName,
			isWallet,
			ownCoupons,
			isBeingRedeemed = false,
			authenticated,
			showLogin
		} = this.props;

		const style = {
			float: 'left',
			width: '100%'
		};

		const actions = showActions && (
			<div className="CouponsActions">
				<button className="CouponsActions-positive" onClick={this.props.onApprove}>
					Accept
				</button>
				<button className="CouponsActions-negative" onClick={this.props.onReject}>
					Reject
				</button>
			</div>
		);

		const couponExpiry = moment(expiryDate, 'YYYY-MM-DD');
		const currentDate = moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD');

		const diffDays = couponExpiry.diff(currentDate, 'days') + 1;

		let showQuantity = false;
		let showSoldOut = false;

		if (coupon.quantity - coupon.totalRedeemed <= 10) {
			showQuantity = true;
		}

		if (coupon.quantity === coupon.totalRedeemed) {
			showSoldOut = true;
		}

		return (
			<section className="CouponCard" onClick={this.couponClickHandler}>
				{showCommunityName ? (
					<div className="communityName">
						<span>{coupon.community.name}</span>
					</div>
				) : null}
				<div className="couponContainer">
					<div style={style}>
						<div className="CouponCard-meta">
							<Avatar
								size={size === 'small' ? 64 : screenSize === 'mobile' ? 100 : 128}
								backgroundImage={avatarImage}
								onClick={this.avtarClickHandler}
							/>
						</div>
						<div className="CouponCard-bio padding-10">
							<h2 className="provider-name" onClick={this.avtarClickHandler}>
								{firstname} {lastname}
							</h2>

							{businessName ? (
								<div className="CouponCard-businessName" onClick={this.avtarClickHandler}>
									{businessName}
								</div>
							) : (
								undefined
							)}
						</div>

						{showOptions && options && (
							<OptionsButton
								className="ProfileCard-options ProfileCard-options-position"
								options={options}
								onClick={e => this.toggleClicked(e)}
							/>
						)}
					</div>
					<div className="float-left">
						<p className="Description">{description}</p>

						{productLink && productLink.length > 0 && (
							<div className="productLink">
								{/* <Link to={{ pathname: productLink }} target="_blank" /> */}
								<a href={productLink} target="_blank" rel="noopener noreferrer">
									{productLink}
								</a>
							</div>
						)}

						<span className="PromoCode">
							Code: <span>{authenticated ? code : '*****'}</span>
						</span>
						<span className="ExpiryDate">
							Expires: {moment(expiryDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
						</span>
					</div>
					<div className="float-left">
						<div className="couponActivityFooter">
							{!showActions && showSoldOut && !isWallet && !ownCoupons && (
								<div className="quantityLeft">
									<span className="soldOut">SOLD OUT</span>
								</div>
							)}

							{!showActions &&
								!showQuantity &&
								!showSoldOut &&
								!ownCoupons &&
								!isWallet &&
								diffDays < 7 && (
									<div className="daysleft">
										<img className="timerImage" src="/timer.png" alt="timer icon" />
										<span>
											Only {diffDays} {diffDays > 1 ? 'days' : 'day'} left!
										</span>
									</div>
								)}

							{!showActions && !showSoldOut && !isWallet && !ownCoupons && showQuantity && (
								<div className="quantityLeft">
									<span>Hurry, Only {coupon.quantity - coupon.totalRedeemed} Left</span>
								</div>
							)}

							{canRedeem && (
								<div className="couponActivityActions">
									<span className="redeemButton">
										{isBeingRedeemed ? (
											<Spinner />
										) : (
											<PrimaryButton
												disabled={redeemDisabled || showSoldOut}
												icon="loyalty"
												onClick={e => {
													e.stopPropagation();
													confirmReedem(coupon);
												}}>
												Redeem
											</PrimaryButton>
										)}
									</span>
								</div>
							)}
						</div>
					</div>
				</div>
				{actions}
			</section>
		);
	}

	/**
	 * Lifecycle method before unmounting component
	 * clear all open models before redirecting
	 */
	componentWillUnmount() {
		this.props.clearModels();
	}
}

const mapStateToProps = state => {
	return {
		authenticated: state.session.status === 'authenticated' ? true : false
	};
};

const mapDispatchToProps = dispatch => {
	return {
		confirmReedem: coupon => {
			dispatch(
				confirmActions.open({
					title: `Are you sure you want to redeem this Coupon?`,
					message: 'The coupon will be added to your coupon cart. Are you sure?',
					onConfirm: () => {
						dispatch(couponActions.redeemCoupon(coupon));
					}
				})
			);
		},
		clearModels: () => {
			dispatch(uiActions.uiModal(''));
		},
		showLogin: () => {
			notificationsActions.requestNotificationPermission();
			dispatch(uiActions.uiModal('login'));
		}
	};
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(CouponCard)
);



// WEBPACK FOOTER //
// ./src/community/coupons/coupon-card/CouponCard.js